import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, ChevronsUpDown } from "lucide-react";

export function CourseCombobox({ courses, value, onChange, testid = "course-combobox", placeholder = "Select a course" }) {
  const [open, setOpen] = useState(false);
  const sorted = [...courses].sort((a, b) => (a.title || "").localeCompare(b.title || ""));
  const current = courses.find((c) => c.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="mt-1.5 flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 text-sm text-left">
          <span className={`truncate ${current ? "" : "text-muted-foreground"}`}>{current ? current.title : placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[320px]" align="start">
        <Command>
          <CommandInput placeholder="Search courses..." data-testid={`${testid}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>No course found.</CommandEmpty>
            {sorted.map((c) => (
              <CommandItem key={c.id} value={`${c.title} ${c.id}`} onSelect={() => { onChange(c.id); setOpen(false); }} data-testid={`${testid}-option-${c.id}`}>
                <Check className={`mr-2 h-4 w-4 ${c.id === value ? "opacity-100" : "opacity-0"}`} />
                <span className="truncate">{c.title}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
